import { useTranslation } from 'next-i18next'

import { useGetProducts } from '~/booking/hooks/useGetProduct'

import { TutorLevel } from '~/types/booking'
import { Product } from '~/types/product'

import PriceItem from './PriceItem'
import usePriceList from './usePriceList'

export default function PricesList({ className = '' }): React.ReactElement {
  const { t } = useTranslation('tutorOnDemand')
  const { data: bookingProducts } = useGetProducts()
  const tutoringProducts = bookingProducts
    ? bookingProducts.tutoringProducts.filter((p: Product) => p.tutorLevel === TutorLevel.TUTOR)
    : []

  const background = usePriceList()
  const style = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
  }

  return (
    <section className={`relative w-full mx-auto ${className}`} style={style}>
      <div className="max-w-xl mx-auto py-14 sm:py-20 space-y-2">
        <h2 className="text-center mb-4 xl:mb-8 text-lg text-white xl:text-h3 font-semibold">
          {t('landingPage.productPrices.title')}
        </h2>
        <section className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {tutoringProducts.map((product: Product) => (
            <PriceItem key={product.type} product={product} />
          ))}
        </section>
      </div>
    </section>
  )
}
